import {
  ManagementLayoutActionTypes,
  ManagementLayoutState,
  SET_MANAGEMENT_LEFT_PANEL_COLLAPSED,
  SET_PROJECT_COUNTS
} from "./types";

const initialManagementLayoutState: ManagementLayoutState = {
  isLeftPanelCollapsed: false
};

export const managementLayoutReducer = (
  state = initialManagementLayoutState,
  action: ManagementLayoutActionTypes
): ManagementLayoutState => {
  switch (action.type) {
    case SET_MANAGEMENT_LEFT_PANEL_COLLAPSED:
      return {
        ...state,
        isLeftPanelCollapsed: action.meta.params.isLeftPanelCollapsed
      };
    case SET_PROJECT_COUNTS:
      return {
        ...state,
        myProjectsCount: action.meta.params.myProjectsCount ?? state.myProjectsCount,
        favoritesCount: action.meta.params.favoritesCount ?? state.favoritesCount
      };
    default:
      return state;
  }
};
